export const Rectangle = () => (
    <svg width="10" height="80" viewBox="0 0 10 80" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0 0H1V69.7097C1 74.6802 5.02944 78.7097 10 78.7097V78.7097V80V80C4.47715 80 0 75.5228 0 70V0Z" fill="#D4DBEA" />
    </svg>
);
